export default __webpack_public_path__ + "static/media/IncredibleAnimalsPredators_01.d537adf1.png";